if(!customElements.get('reviews-component')) {
  customElements.define(
    'reviews-component',
    class ReviewsComponent extends HTMLElement {
      #sliderEl;
      #sliderInstance;

      constructor() {
        super();
      }

      connectedCallback() {
        this.#sliderEl = this.querySelector('[data-slider]');
        this.init();
      }

      init() {
        if(!this.#sliderEl) return;

        const sectionId = this.dataset.sectionId;

        const options = {
          slidesPerView: 1,
          spaceBetween: 12,
          breakpoints: {
            768: {
              slidesPerView: 2
            },
            1024: {
              slidesPerView: 1.4,
            },
            1360: {
              slidesPerView: 1.9,
              spaceBetween: 16
            }
          },
          navigation: {
            prevEl: `.slider-button[data-section-id="${sectionId}"].prev`,
            nextEl: `.slider-button[data-section-id="${sectionId}"].next`,
          },
          pagination: {
            el: this.parentNode.parentNode.querySelector('.slider-pagination'),
            type: "bullets",
            clickable: true
          }
        };

        this.#sliderInstance = new Swiper(this.#sliderEl, options);
      }
    }
  );
}